<template lang="pug">
.node-settings(v-scrollbar.y="")
	.actions

	template(v-if="question")
		bunt-input(name="id", label="ID", v-model="id")
		.question-input
			bunt-input-outline-container(v-if="questionText.function", label="Question Function")
				monaco-editor(v-model="questionText.function", language="javascript", slot-scope="{focus, blur}", @focus="focus", @blur="blur")
			bunt-input(v-else, name="question", label="Question", v-model="questionText")
			bunt-icon-button(@click="toggleQuestionIsFunction") {{ question.question.function ? 'format_text' : 'function_variant' }}
		bunt-select(name="answerType", label="Type", v-model="type", :options="ANSWER_TYPES")
		bunt-input-outline-container(label="Show If")
			monaco-editor(v-model="showIf", language="javascript", slot-scope="{focus, blur}", @focus="focus", @blur="blur")
		h5 Options
		.options
			settings-option(v-for="option in question.answer.options", :option="option")
			bunt-icon-button(@click="addOption") add
</template>
<script>
import { mapState } from 'vuex'
import MonacoEditor from 'components/monaco-editor'
import SettingsOption from './settings-option'

const ANSWER_TYPES = [
	'text',
	'date',
	'number',
	'currency',
	'chooseOne',
	'chooseMany',
]

export default {
	components: { MonacoEditor, SettingsOption },
	data () {
		return {
			ANSWER_TYPES,
			_id: null
		}
	},
	computed: {
		...mapState({
			question: 'selectedQuestion'
		}),
		...mapState(['questionsLookup']),
		id: {
			get () {
				return this._id || this.question.id
			},
			set (value) {
				if (this.questionsLookup[value]) {
					this._id = value
				} else {
					this._id = null
					this.$store.dispatch('updateQuestion', {
						question: this.question,
						update: {
							id: value
						}
					})
				}
			}
		},
		questionText: {
			get () {
				return this.question.question
			},
			set (value) {
				this.$store.dispatch('updateQuestion', {
					question: this.question,
					update: {
						question: value
					}
				})
			}
		},
		type: {
			get () {
				return this.question.answer.type
			},
			set (value) {
				this.$store.dispatch('updateQuestion', {
					question: this.question,
					update: {
						answer: Object.assign(this.question.answer, {type: value})
					}
				})
			}
		},
		showIf: {
			get () {
				return this.question.showIf
			},
			set (value) {
				this.$store.dispatch('updateQuestion', {
					question: this.question,
					update: {
						showIf: value === '' ? null : value
					}
				})
			}
		},
	},
	created () {},
	mounted () {
		this.$nextTick(() => {
		})
	},
	methods: {
		toggleQuestionIsFunction () {
			if (this.question.question.function) {
				this.$store.dispatch('updateQuestion', {
					question: this.question,
					update: {
						question: this.question.question.function
					}
				})
			} else {
				let functionText
				if (this.question.question.startsWith('return')) {
					functionText = this.question.question
				} else {
					functionText = `return '${this.question.question}'`
				}
				this.$store.dispatch('updateQuestion', {
					question: this.question,
					update: {
						question: {
							function: functionText
						}
					}
				})
			}
		},
		addOption () {
			this.$store.dispatch('addOption', {
				question: this.question,
				option: {
					text: '',
					value: null,
					next: null
				}
			})
		}
	}
}
</script>
<style lang="stylus">
@import '~settings'
.node-settings
	card()
	width: 560px
	padding: 8px 16px
	.bunt-input
		input-style(size: 'compact')
	.bunt-icon-button
		icon-button-style(style: 'clear')
	.bunt-input-outline-container
		margin: 16px 0
		box-sizing: border-box
		padding: 16px 4px
		.c-monaco-editor
			min-height: 100px
	.question-input
		display: flex
		align-items: flex-end
		.bunt-input, .bunt-input-outline-container
			flex: auto
		.c-monaco-editor
			min-height: 200px
		.bunt-icon-button
			margin: 0 0 0 8px
			flex: none
			icon-button-style(style: 'clear')

	.options
		display: flex
		flex-direction: column
		.bunt-icon-button
			align-self: center
</style>
